export const WHAT_PLAN_THERAPY = 7239410;
export const FAQ_PLAN_THERAPY = 7239410;
export const SPECIALIST_MATCH = 6976081;
export const SPECIALIST_STATISTIC = 6976006;
export const BOOKING_FAQ = 7239410;
export const SUBSCRIPTION_CONTROL = 7239410;
export const SUBSCRIPTION_PAUSE = 7238522;
export const SUBSCRIPTION_CANCELED = 7238551;
export const SUBSCRIPTION_WHY_NOT_PAUSED = 7238491;
export const SUBSCRIPTION_WHAT_THERAPY_PLAN_IS = 7067819;
export const SUBSCRIPTION_HOW_TO_UNPAUSE = 7238482;
export const SUBSCRIPTION_WHY_NOT_CANCEL = 7238494;
export const SUBSCRIPTION_WHY_NOT_BUY = 7238493;
export const SUBSCRIPTION_NOT_DO_IN_TIME = 7238468;
export const HOW_SESSIONS_WORK = 6990752;
export const FIRST_BOOKING_FAQ = 7170292;
export const AUTH_FAQ = 6922552;
export const UPDATE_FAQ = 7906091;
export const NEW_SPECIALIST_ARTICLE = 10545513;
